module.exports = __webpack_public_path__ + "img/login-illus.c655d02c.svg";